import { connect } from 'react-redux';
import { logout } from 'core/slices/users';
import OptionsMenu from '../../../components/navbar/OptionsMenu';

export default connect(
  null,
  { logout }
)(OptionsMenu); 